var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.387,
    height: 23.387,
    viewBox: "0 0 23.387 23.387",
    fill: "#962f2f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-linkedin-3_1_",
    "data-name": "iconmonstr-linkedin-3 (1)",
    d: "M18.515,0H4.872A4.873,4.873,0,0,0,0,4.872V18.515a4.873,4.873,0,0,0,4.872,4.872H18.515a4.872,4.872,0,0,0,4.872-4.872V4.872A4.872,4.872,0,0,0,18.515,0ZM7.8,18.515H4.872V7.8H7.8ZM6.334,6.56A1.719,1.719,0,1,1,8.039,4.841,1.713,1.713,0,0,1,6.334,6.56ZM19.489,18.515H16.566V13.054c0-3.282-3.9-3.033-3.9,0v5.461H9.745V7.8h2.923v1.72c1.36-2.52,6.821-2.706,6.821,2.413Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b52b89fec612edd158c8904168952ce7.svg";
export { ForwardRef as ReactComponent };